// Codici dei paesi: ISO alpha-3 → alpha-2 (bandiere, nomi) e codici proprietario del catalogo SATCAT → alpha-3.
// Modulo senza dipendenze: lo usano il sito e il Worker (pagine dei paesi, sitemap).

export const ALPHA3: Record<string, string> = {
  USA: 'US', CHN: 'CN', RUS: 'RU', FRA: 'FR', ITA: 'IT', IND: 'IN', JPN: 'JP', KOR: 'KR', PRK: 'KP', IRN: 'IR',
  ISR: 'IL', DEU: 'DE', GBR: 'GB', NZL: 'NZ', AUS: 'AU', BRA: 'BR', CAN: 'CA', LUX: 'LU', FIN: 'FI', ARG: 'AR',
  ESP: 'ES', KAZ: 'KZ', GUF: 'GF', TWN: 'TW', SWE: 'SE', NOR: 'NO', TUR: 'TR', ARE: 'AE', POL: 'PL', SGP: 'SG',
  IDN: 'ID', GRC: 'GR', CHE: 'CH', NLD: 'NL', DNK: 'DK', SAU: 'SA', BEL: 'BE', CZE: 'CZ', THA: 'TH', EGY: 'EG',
  MYS: 'MY', MEX: 'MX', PAK: 'PK', PRT: 'PT', LTU: 'LT', RWA: 'RW', UKR: 'UA', ZAF: 'ZA', HUN: 'HU', PHL: 'PH',
  BGR: 'BG', NGA: 'NG', BLR: 'BY', AUT: 'AT', AZE: 'AZ', PER: 'PE', SVK: 'SK', MAR: 'MA', SVN: 'SI', COL: 'CO',
  VEN: 'VE', KWT: 'KW', IRL: 'IE', QAT: 'QA', CHL: 'CL', VNM: 'VN', EUR: 'EU',
};

/** Codici proprietario del catalogo SATCAT → ISO alpha-3 (solo i paesi; le organizzazioni non hanno bandiera, tranne l'ESA). */
export const SATCAT_A_ALPHA3: Record<string, string> = {
  US: 'USA', CIS: 'RUS', PRC: 'CHN', FR: 'FRA', JPN: 'JPN', IND: 'IND', UK: 'GBR', GER: 'DEU', IT: 'ITA', CA: 'CAN',
  SPN: 'ESP', SKOR: 'KOR', AUS: 'AUS', ARGN: 'ARG', ISRA: 'ISR', TURK: 'TUR', ROC: 'TWN', FIN: 'FIN', IRAN: 'IRN',
  UAE: 'ARE', BRAZ: 'BRA', POL: 'POL', NOR: 'NOR', SING: 'SGP', LUXE: 'LUX', NZ: 'NZL', INDO: 'IDN', GREC: 'GRC',
  SWTZ: 'CHE', NETH: 'NLD', DEN: 'DNK', SAUD: 'SAU', BEL: 'BEL', CZCH: 'CZE', THAI: 'THA', SWED: 'SWE', EGYP: 'EGY',
  MALA: 'MYS', MEX: 'MEX', PAKI: 'PAK', POR: 'PRT', LTU: 'LTU', RWA: 'RWA', UKR: 'UKR', SAFR: 'ZAF', HUN: 'HUN',
  RP: 'PHL', BUL: 'BGR', KAZ: 'KAZ', NKOR: 'PRK', CHLE: 'CHL', VTNM: 'VNM', NIG: 'NGA', BELA: 'BLR', ASRA: 'AUT',
  AZER: 'AZE', PERU: 'PER', SVK: 'SVK', MA: 'MAR', SVN: 'SVN', COL: 'COL', VENZ: 'VEN', KWT: 'KWT', IRL: 'IRL',
  QAT: 'QAT', ESA: 'EUR',
};

export const alpha3DaSatcat = (codice: string): string | null => SATCAT_A_ALPHA3[codice] ?? null;
/** Il contrario: dal codice ISO alpha-3 al codice proprietario del catalogo (per ritrovare un paese dal suo indirizzo). */
export const satcatDaAlpha3 = (a3: string): string | null => Object.entries(SATCAT_A_ALPHA3).find(([, v]) => v === a3)?.[0] ?? null;
